import { render, staticRenderFns } from "./2DcheckLabel.vue?vue&type=template&id=9b1fd960&scoped=true"
import script from "./2DcheckLabel.vue?vue&type=script&lang=js"
export * from "./2DcheckLabel.vue?vue&type=script&lang=js"
import style0 from "./2DcheckLabel.vue?vue&type=style&index=0&id=9b1fd960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1fd960",
  null
  
)

export default component.exports